import E from "wangeditor";

const { BtnMenu } = E;

export default class StandardWording extends BtnMenu {
  constructor(editor) {
    const $elem = E.$(
      `<div class="w-e-menu" data-title="标准话术">
        <div class="w-e-up-btn">
          <i class="el-icon-document-copy"></i>
        </div>
      </div>`,
    );
    super($elem, editor);
  }

  clickHandler() {
    if (this.editor.customWordingHandler) {
      this.editor.customWordingHandler();
    }
  }

  tryChangeActive() {
    this.unActive();
  }
}
